import { Response } from 'node-fetch';
export { Response };
const getFetch = () => {
    if (typeof window === 'undefined' || !window.fetch) {
        /* eslint-disable */
        return require('node-fetch');
    }
    return window.fetch;
};
export const fetch = getFetch();
//# sourceMappingURL=fetch.js.map